/*
 *             Copyright (c) 2016 - 2022, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
const _0x567f=['get','RestrictedEditingModeEditing','has','addCommentThread','enableCommand','plugins'];(function(_0x17b5e2,_0x567f0c){const _0x2e3b0a=function(_0x2d951e){while(--_0x2d951e){_0x17b5e2['push'](_0x17b5e2['shift']());}};_0x2e3b0a(++_0x567f0c);}(_0x567f,0xc7));const _0x2e3b=function(_0x17b5e2,_0x567f0c){_0x17b5e2=_0x17b5e2-0x0;let _0x2e3b0a=_0x567f[_0x17b5e2];return _0x2e3b0a;};import{Plugin as _0x4769c9}from'ckeditor5/src/core';export default class F extends _0x4769c9{['afterInit'](){const _0x2c6ff8=this['editor'];if(!_0x2c6ff8[_0x2e3b('0x4')][_0x2e3b('0x1')]('RestrictedEditingModeEditing'))return;_0x2c6ff8[_0x2e3b('0x4')][_0x2e3b('0x5')](_0x2e3b('0x0'))[_0x2e3b('0x3')](_0x2e3b('0x2'));}}